<template>
    <article class="clients">
        <section>
            <h3 class="text-center">Bienvenido a el mundo del catálogo</h3>
            <p class="text-center">
                Por favor seleccione una sucursal e ingrese su numero de cliente para obtener Información referente a sus pedidos..
            </p>
        </section>
        <section class="mt-4">
            <div class="row justify-content-center">
                <div class="col-3 text-center">
                    <div class="form-group">
                        <label for="sucursal">SUCURSAL</label>
                        <select name="" id="sucursal" class="form-control" v-model="search.enterprise_id">
                            <option v-for="(o, key) in options" :value="o.value" :key="key">{{ o.text }}</option>
                        </select>
                    </div>
                </div>
                <div class="col-3 text-center">
                    <div class="form-group">
                        <label for="cliente">CLIENTE</label>
                        <input type="number" name="" class="form-control" id="cliente" v-model="search.id_client">
                    </div>
                </div>
                <div class="col-1 text-rigth">
                    <div class="form-group mt-4">
                        <button class="btn btn-success" @click="getOrders">Buscar</button>
                    </div>
                </div>
            </div>
        </section>
        {{ rows }}
        <section class="mt-5" v-if="rows.length > 0">
            <div class="row justify-content-center">
                <b-table
                selectable
                class="table-adelantazo"
                :select-mode="selectMode"
                responsive="sm"
                ref="selectableTable"
                @row-selected="onRowSelected"
                selectedVariant="success"
                show-empty
                stacked="md"
                :items="rows"
                :fields="fields"
                :current-page="currentPage"
                :per-page="perPage"
                :filter="filter"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :sort-direction="sortDirection"
              >
                <template
                  v-slot:cell(date)="row"
                >{{ getDateFormatEpoch(row.item.date) }}</template>
                <template v-slot:cell(total)="row">
                  <div align="center" class="history-amount">
                    <span v-html="getFormattedAmount(row.item)" />
                  </div>
                </template>
                <template v-slot:cell(action)="row">
                  <div align="center" class="history-amount">
                      <button class="btn btn-purple" @click="showDetail(row)">Detalle</button>
                  </div>
                </template>
                <template #cell(selected)="{ rowSelected }">
                  <template v-if="rowSelected">
                    <span aria-hidden="true">&check;</span>
                    <span class="sr-only">Selected</span>
                  </template>
                  <template v-else>
                    <span aria-hidden="true">&nbsp;</span>
                    <span class="sr-only">Not selected</span>
                  </template>
                </template>
                <!-- <div slot="RequestDate" slot-scope="row">{{ row }}</div> -->
              </b-table>
            </div>
        </section>
    </article>
</template>
<script>
import axiosAdelaService from '@/axios/axiosAdelaService'
import { BTable } from 'bootstrap-vue'

export default {
  components: {
    BTable
  },
  data () {
    return {
      options: [],
      search: {
        enterprise_id: null,
        id_client: ''
      },
      rows: [],
      fields: [
        { key: 'folio', label: 'Folio', sortable: true, sortDirection: 'desc' },
        { key: 'cantidad', label: 'Cantidad de Productos', sortable: true, sortDirection: 'desc' },
        { key: 'total', label: 'Total de Devolución', sortable: true, sortDirection: 'desc' },
        { key: 'status', label: 'Estatus', sortable: true, sortDirection: 'desc' },
        { key: 'create_at', label: 'Fecha de Devolución', sortable: true, sortDirection: 'desc' },
        { key: 'action', label: 'Detalle' }
      ]
    }
  },
  methods: {
    async getSucursales () {
      const response = await axiosAdelaService.post('/getEnterprises')
      if (response.status === 200) {
        this.options.push({
          text: 'SELECCIONE UNA OPCIÓN',
          value: null
        })
        response.data.rows.forEach(element => {
          this.options.push({ text: element.name, value: element.id })
        })
        // this.enterprises = response.data
      }
    },
    async getOrders () {
      if (this.search.enterprise_id === null) {
        this.showError('POR FAVOR SELECCIONE UNA SUCURSAL')
        return
      }
      if (this.search.id_client === '') {
        this.showError('POR FAVOR SELECCIONE UNA SUCURSAL')
        return
      }
      try {
        this.rows = []
        const request = {
          ...this.search
        }
        const response = await axiosAdelaService.post('/getOrdersActivesClient', request)
        if (response.status === 200) {
          this.rows = response.data.rows.filter(el => {
            return el.status === 'Inventario'
          })
        }
      } catch (error) {
        console.log(error)
      }
    }
  },
  mounted  () {
    this.getSucursales()
  }
}
</script>
<style>
.clients {
    color: white;
}
</style>
